import { FC } from "react";

import { ToolUIPart, UIMessage } from "ai";

import { ApprovalCard } from "./ApprovalCard";

import { useAssistantConfig } from "../../../contexts/AssistantConfigContext";

interface ConnectedApprovalCardProps {
  part: Extract<ToolUIPart, { state: "approval-requested" }>;
  messages: UIMessage[];
  onAnswerApproval: (approvalId: string, approved: boolean, note?: string) => void;
}

export const ConnectedApprovalCard: FC<ConnectedApprovalCardProps> = ({ part, messages, onAnswerApproval }) => {
  const { useApprovalContent } = useAssistantConfig();
  const { description, details, noteLabel, approveLabel, canApprove, noteValue } = useApprovalContent(part, messages);
  return (
    <ApprovalCard
      description={description}
      details={details}
      noteLabel={noteLabel}
      approveLabel={approveLabel}
      approveDisabled={canApprove === false}
      onApprove={(note) => onAnswerApproval(part.approval.id, true, noteValue ?? note)}
      onDecline={() => onAnswerApproval(part.approval.id, false)}
    />
  );
};
